import { FC } from 'react'
import { Alert } from './Alert'
import { Confirm } from './Confirm'

const Dialogs: FC = () => {
    return (
        <>
            <Confirm />
            <Alert />
        </>
    )
}

export default Dialogs
